(() => {
  const SECTION_SELECTOR = '[data-bianchi-signature-gallery]';
  const CATEGORY_LIMITS = {
    pregatiri: 2,
    ceremonia: 2,
    atmosfera: 2,
    petrecerea: 4,
    detalii: 2
  };
  const BATCH_SIZE = 12;

  function initGallery(section) {
    if (!section || section.dataset.bsgInitialized === 'true') return;

    const items = Array.from(section.querySelectorAll('[data-bsg-item]'));
    const filters = Array.from(section.querySelectorAll('[data-bsg-filter]'));
    const loadMore = section.querySelector('[data-bsg-load-more]');
    const note = section.querySelector('[data-bsg-note]');
    const lightbox = section.querySelector('[data-bsg-lightbox]');

    if (!items.length) {
      if (loadMore) loadMore.classList.add('is-hidden');
      return;
    }

    section.dataset.bsgInitialized = 'true';

    let activeFilter = 'all';
    let visibleLimit = BATCH_SIZE;
    let activeList = [];
    let lightboxIndex = 0;
    let touchStartX = 0;

    const notes = {
      all: section.querySelector('[data-bsg-filter="all"]')?.textContent?.trim() || 'Toate',
      pregatiri: 'Fiecare detaliu incepe cu linistea dinaintea evenimentului.',
      ceremonia: 'Momentul in care toate deciziile dispar si ramane doar emotia.',
      atmosfera: 'Lumina, parfumul, muzica si oamenii transforma un spatiu intr-o amintire.',
      petrecerea: 'Bucuria nu se planifica. Dar se creeaza contextul in care apare.',
      detalii: 'Uneori cele mai mici lucruri sunt cele pe care le pastrezi cel mai mult.'
    };

    const getAllSelection = () => {
      const selected = [];
      const used = new Set();

      Object.entries(CATEGORY_LIMITS).forEach(([category, limit]) => {
        items
          .filter((item) => item.dataset.bsgCategory === category)
          .slice(0, limit)
          .forEach((item) => {
            selected.push(item);
            used.add(item);
          });
      });

      items.forEach((item) => {
        if (!used.has(item)) selected.push(item);
      });

      return selected;
    };

    const getFilteredItems = () => {
      if (activeFilter === 'all') return getAllSelection();
      return items.filter((item) => item.dataset.bsgCategory === activeFilter);
    };

    const render = () => {
      const filtered = getFilteredItems();
      activeList = filtered.slice(0, visibleLimit);

      items.forEach((item) => item.classList.remove('is-visible'));
      activeList.forEach((item) => item.classList.add('is-visible'));

      if (loadMore) {
        loadMore.classList.toggle('is-hidden', filtered.length <= visibleLimit);
      }

      if (note) {
        note.textContent = activeFilter === 'all'
          ? 'O selectie din momentele care au construit primul proiect Signature.'
          : notes[activeFilter];
      }
    };

    const setFilter = (filter) => {
      activeFilter = filter;
      visibleLimit = BATCH_SIZE;

      filters.forEach((button) => {
        const isActive = button.dataset.bsgFilter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      render();
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        setFilter(button.dataset.bsgFilter || 'all');
      });
    });

    if (loadMore) {
      loadMore.addEventListener('click', () => {
        visibleLimit += BATCH_SIZE;
        render();
      });
    }

    section.querySelectorAll('[data-bsg-scroll]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return;

        const target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    const getImageData = (item) => {
      const img = item.querySelector('img');
      return {
        src: img?.currentSrc || img?.src || '',
        alt: img?.alt || '',
        title: item.dataset.bsgTitle || '',
        caption: item.dataset.bsgCaption || ''
      };
    };

    const updateLightbox = () => {
      if (!lightbox || !activeList.length) return;

      const data = getImageData(activeList[lightboxIndex]);
      const image = lightbox.querySelector('[data-bsg-lightbox-image]');
      const caption = lightbox.querySelector('[data-bsg-lightbox-caption]');
      const counter = lightbox.querySelector('[data-bsg-lightbox-counter]');

      if (image) {
        image.src = data.src;
        image.alt = data.alt;
      }

      if (caption) {
        caption.textContent = data.caption || data.title || data.alt || '';
      }

      if (counter) {
        counter.textContent = `${lightboxIndex + 1} / ${activeList.length}`;
      }
    };

    const openLightbox = (item) => {
      if (!lightbox) return;
      const index = activeList.indexOf(item);
      if (index < 0) return;

      lightboxIndex = index;
      updateLightbox();
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };

    const moveLightbox = (direction) => {
      if (!activeList.length) return;
      lightboxIndex = (lightboxIndex + direction + activeList.length) % activeList.length;
      updateLightbox();
    };

    items.forEach((item) => {
      const openButton = item.querySelector('[data-bsg-open]');
      if (openButton) {
        openButton.addEventListener('click', () => openLightbox(item));
      }
    });

    if (lightbox) {
      lightbox.querySelectorAll('[data-bsg-lightbox-close]').forEach((button) => {
        button.addEventListener('click', closeLightbox);
      });

      lightbox.querySelector('[data-bsg-lightbox-prev]')?.addEventListener('click', () => moveLightbox(-1));
      lightbox.querySelector('[data-bsg-lightbox-next]')?.addEventListener('click', () => moveLightbox(1));

      lightbox.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
      }, { passive: true });

      lightbox.addEventListener('touchend', (event) => {
        const touchEndX = event.changedTouches[0]?.clientX || 0;
        const delta = touchEndX - touchStartX;
        if (Math.abs(delta) < 48) return;
        moveLightbox(delta > 0 ? -1 : 1);
      }, { passive: true });
    }

    document.addEventListener('keydown', (event) => {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;

      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') moveLightbox(-1);
      if (event.key === 'ArrowRight') moveLightbox(1);
    });

    render();
  }

  function init(root = document) {
    root.querySelectorAll(SECTION_SELECTOR).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
